import { createWorkingHours } from "../../utils/working-hours.mjs";
const defaultWorkingHours = createWorkingHours("09:00", "18:00", [1, 2, 3, 4, 5]);
export {
  defaultWorkingHours
};
//# sourceMappingURL=working-hours.mjs.map
